import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

const Citah4 = styled.h4`
  font-size: 22px;
  line-height: 31px;
  font-weight: 300;
  color: ${colors.main};
  text-transform: uppercase;
  &:before {
    margin: 15px 0 15px 0;
    display: block;
    content: '';
    width: 40px;
    height: 5px;
    background: ${colors.black};
  }
`;

const Nombre = styled.h5`
  font-size: 11px;
  color: ${colors.black};
  text-transform: uppercase;
  font-family: ${fonts.sans}, sans-serif;
  letter-spacing: .1rem;
  padding-bottom: 1em;
`;

const Cargo = styled.span`
  font-weight: 300;
  color: ${colors.oscuro};
  font-family: ${fonts.sans}, sans-serif;
`;

const Cita = ({ contenido, nombre, cargo }) => (
  <div>
    <Citah4>“{contenido}”</Citah4>
    <Nombre>{nombre} <Cargo>{cargo}</Cargo> </Nombre>

  </div>
);

export default Cita;



// WEBPACK FOOTER //
// ./src/components/Cita.js